import { useEffect } from 'react';

import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { LexExperimentEvents_EventType as LexExperimentsEventType } from '__generated__/graphql-types';

import type {
  QueryByEventTypeQuery,
  QueryByEventTypeQueryVariables,
} from 'bundles/course-v2/event-management/queries/__generated__/queryByEventType';
import queryByEventTypeQuery from 'bundles/course-v2/event-management/queries/queryByEventType.graphql';

type UseQueryByEventTypeProps = {
  eventType: LexExperimentsEventType;
  skip?: boolean;
};

export const useQueryByEventType = ({ eventType, skip = false }: UseQueryByEventTypeProps) => {
  const { loading, error, data, refetch } = useQuery<QueryByEventTypeQuery, QueryByEventTypeQueryVariables>(
    queryByEventTypeQuery,
    {
      variables: { eventType },
      context: { clientName: 'gatewayGql' },
      skip,
    }
  );

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return {
    loading,
    error,
    data,
    refetch,
  };
};
